import api from './config';

// Get all blog posts (admin — includes drafts)
export const getBlogPosts = async (params = {}) => {
  try {
    const response = await api.get('/blog-posts', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get published blog posts (public)
export const getPublishedBlogPosts = async (params = {}) => {
  try {
    const response = await api.get('/blog-posts/published', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single blog post by id (admin, for editing)
export const getBlogPost = async (id) => {
  try {
    const response = await api.get(`/blog-posts/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single published blog post by slug (public)
export const getBlogPostBySlug = async (slug) => {
  try {
    const response = await api.get(`/blog-posts/slug/${slug}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Create new blog post
export const createBlogPost = async (formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await api.post('/blog-posts', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update blog post
export const updateBlogPost = async (id, formData) => {
  try {
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const response = await api.put(`/blog-posts/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete blog post
export const deleteBlogPost = async (id) => {
  try {
    const response = await api.delete(`/blog-posts/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Toggle publish status
export const toggleBlogPostStatus = async (id) => {
  try {
    const response = await api.patch(`/blog-posts/${id}/status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get blog post statistics
export const getBlogPostStats = async () => {
  try {
    const response = await api.get('/blog-posts/stats');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
